<template>
    <span class="text-red500 text-md">*</span>
</template>
